import factory from 'theme/base/base';
import system from 'helpers/system';
import constants from 'helpers/constants';

let themeOverrides = {
  name: 'dark',
  palette: {
    mode: 'dark'
  },
  components: {
    // Button: {
    //   styleOverrides: {
    //     root: {
    //     },
    //     schemaBlue: {
    //       backgroundColor: (theme) => theme.property('palette.blue.A400'),
    //       border: (theme) => `2px solid ${theme.property('palette.blue.A700')}`
    //     },
    //     sizeLarge: {
    //       fontSize: (theme) => theme.fontSize(32)
    //     },
    //     sizeMedium: {
    //       backgroundColor: 'red'
    //     }
    //   }
    // },
  },
};

const whiteLabel = system.whiteLabel();
if (whiteLabel) {
  const whiteLabelDef = constants.data.lookup('whiteLabels', whiteLabel)
  if (whiteLabelDef?.factories?.theme?.dark) {
    themeOverrides = whiteLabelDef.factories.theme.dark(themeOverrides);
  }
}

const themeDark = factory(themeOverrides);

export default themeDark;

